import { mapValues } from 'lodash';

import { ISelectModel } from 'common/models';

export const encodeUriFilters = (
  _params: Record<
    string,
    string | string[] | number | ISelectModel<string>[] | boolean | Date | null
  >,
) => mapValues(_params, value => (typeof value === 'string' ? encodeURIComponent(value) : value));

export const decodeUriFilters = (_params: Record<string, string | string[] | null>) =>
  mapValues(_params, value => (typeof value === 'string' ? decodeURIComponent(value) : value));
